module.exports = __webpack_public_path__ + "img/Pakistan StudiesEx.d9fdfaf4.svg";